import React from 'react'
// components
import Tooltip from '@mui/material/Tooltip'
// views
import { Button } from './views'

interface IProps extends React.HTMLAttributes<HTMLDivElement> {
  description: string
  children: React.ReactNode
}

// Icon button of the plan item actions pill, with its description shown on hover. Extra props
// (e.g. the onClick injected by PopoverModal into its trigger) are passed through to the button.
const ActionButton: React.FC<IProps> = ({ description, children, ...props }) => (
  <Tooltip title={description}>
    <Button {...props}>{children}</Button>
  </Tooltip>
)

export default ActionButton
